<template>
  <!-- w -35 h -26 -->
  <path
    d="M0 13.5714H33M33 13.5714L23.1702 1M33 13.5714L23.1702 25"
    stroke="currentColor"
    stroke-width="2" />
</template>
